export const articleConstants = {
  GET_ALL_REQUEST: 'ARTICLE_GET_ALL_REQUEST',
  GET_ALL_SUCCESS: 'ARTICLE_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'ARTICLE_GET_ALL_FAILURE',
};
